{
	"title": "नाकाज़ावा 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "पूर्ण स्क्रीन",
		"achievements": "उपलब्धियां",
		"reset": "रीसेट",
		"language": "भाषा"
	},
	"achievements": {
		"title": "उपलब्धियां",
		"noAchievements": "अभी तक कोई उपलब्धि नहीं मिली। क्लिक करते रहें!",
		"unlocked": "उपलब्धि अनलॉक: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 नौसिखिया खरगोश",
		"carrotSnatcher": "🥕 सब्जी चोर",
		"bunnyBerserker": "😡 क्रोधित खरगोश",
		"hopPunk": "🎸 विद्रोही खरगोश",
		"bunnyNinja": "🥷 शांत पर घातक",
		"expert": "🌟 विशेषज्ञ कूदने वाला",
		"master": "👑 गाजर का राजा",
		"carrotpocalypse": "🥕 बगीचे का विनाशक",
		"bunnyOverlord": "😈 खरगोश बिल का सर्वोच्च शासक",
		"chaosHare": "🌪️ अराजकता का दूत",
		"carrotCultist": "⛪ गाजर पंथ का महापुजारी",
		"bunnyberryPie": "🥧 भ्रामक पाई मास्टर",
		"rabbitHole": "🕳️ क्वांटम सुरंग खोदने वाला",
		"moonRabbit": "🌙 चंद्र खरगोश",
		"bunnyDoom": "💀 खरगोश प्रलय का अग्रदूत",
		"carrotNuke": "☢️ परमाणु गाजर धारक",
		"bunnyMatrix": "🤖 खरगोश मैट्रिक्स में गड़बड़ी",
		"cosmicHare": "🌌 ब्रह्मांडीय खरगोश का जागरण",
		"warrenSingularity": "🕳️ खरगोश बिल विलक्षणता प्राप्त",
		"eternalBunny": "♾️ शाश्वत खरगोश"
	},
	"messages": {
		"prophecy": "प्राचीन क्लिकिंग भविष्यवाणी खुलने लगी है...",
		"cosmic": "ब्रह्मांडीय क्लिकर्स आपकी प्रगति पर गर्व करेंगे!",
		"astral": "क्लिक की गूंज अस्ट्रल प्लेन में फैलती है...",
		"speaking": "रुको... क्या तुमने सुना? क्लिक्स मुझसे बात कर रहे हैं...",
		"ancient": "आपका क्लिकिंग प्राचीन शक्ति से गूंजता है!",
		"sages": "क्लिक ऋषि आपकी क्षमता के बारे में फुसफुसाते हैं...",
		"demons": "देखो! क्लिक राक्षस अपनी नींद से जाग रहे हैं!",
		"veil": "आपके क्लिक्स वास्तविकता के पर्दे को भेदते हैं!",
		"spirits": "क्लिक आत्माएं आपकी लय पर नृत्य करती हैं...",
		"council": "महान क्लिक परिषद ने आपकी समर्पण पर ध्यान दिया है",
		"primordial": "आपका क्लिकिंग आदिम शक्तियों को जगाता है!",
		"void": "क्लिकिंग शून्य आप पर वापस नज़र डालता है...",
		"runes": "प्राचीन क्लिक रून्स आपकी शक्ति से चमकते हैं!",
		"beast": "तीन तीन तीन - क्लिक राक्षस का अंक",
		"prophets": "क्लिक भविष्यवक्ता आपके आगमन का गान करते हैं!",
		"dimensions": "आपके क्लिक्स आयामों में गूंजते हैं...",
		"portal": "आपके क्लिक्स ने क्लिक आयाम का द्वार खोल दिया है!",
		"sacrifice": "प्राचीन क्लिक देवता और बलिदान मांगते हैं",
		"jackpot": "जैकपॉट! क्लिक कैसीनो अपने नए चैंपियन का स्वागत करता है!",
		"unmatched": "आपकी क्लिक शक्ति अद्वितीय है!",
		"reality": "वास्तविकता स्वयं आपकी क्लिकिंग इच्छा के आगे झुकती है!",
		"elite": "आप एलीट क्लिक मास्टर बन गए हैं",
		"power": "आपका क्लिकिंग पावर लेवल 1500 से ऊपर है!",
		"devils": "क्लिक शैतान आपकी शक्ति के सामने झुकते हैं",
		"lucky": "भाग्यशाली क्लिक्स आपकी नसों में बहते हैं",
		"dynasty": "क्लिक राजवंश आपकी श्रेष्ठता को पहचानता है",
		"twoThousand": "शुद्ध शक्ति के दो हजार क्लिक्स!",
		"quartet": "क्लिक चतुष्क की भविष्यवाणी पूरी हुई",
		"transcend": "आपका क्लिकिंग नश्वर समझ से परे है",
		"constellation": "क्लिक नक्षत्र आपके सम्मान में संरेखित होते हैं",
		"destiny": "नियति के तीन हजार क्लिक्स",
		"triforce": "ट्रिपल क्लिक त्रिशक्ति जागृत होती है!",
		"fortune": "भाग्य दृढ़ क्लिकर का साथ देता है",
		"newDimensions": "आपकी क्लिकिंग शक्ति नए आयामों तक पहुंचती है",
		"quartet2": "चौगुना क्लिक चतुष्क सामंजस्य बनाता है",
		"threshold": "क्लिक दिव्यता की दहलीज पर खड़े हैं",
		"ultimate": "परम शक्ति के पांच हजार क्लिक्स!",
		"force": "पांच उंगली क्लिक फोर्स आपके नियंत्रण में है",
		"underworld": "क्लिक पाताल आपको अपना शासक बनाता है",
		"maxJackpot": "अधिकतम जैकपॉट क्लिकिंग प्राप्त की",
		"infinite": "अनंत क्लिकिंग शक्ति!",
		"godhood": "आप क्लिक देवत्व तक पहुंच गए हैं",
		"burrow": "आपने किसी भी खरगोश से ज़्यादा गहरा खोदा है...",
		"warren": "महान खरगोश बिल आपकी उपस्थिति को पहचानता है...",
		"thump": "आपके हर पैर के थंप से धरती कांपती है!",
		"darkWarren": "अंधेरा खरगोश बिल आपके लिए अपने द्वार खोलता है...",
		"ears": "आपके कान लंबे होते जा रहे हैं... अब आप सब कुछ सुन सकते हैं...",
		"carrotThrone": "गाजर का सिंहासन आपके सामने प्रकट होता है...",
		"onesAlignment": "सभी एक संरेखित होते हैं - खरगोश बिल की आवृत्ति गूंजती है!",
		"moonSummon": "चंद्र खरगोश शून्य के पार आपकी पुकार सुनता है...",
		"edgeOfForever": "आप अनंत के किनारे पर खड़े हैं... कान फड़फड़ा रहे हैं...",
		"beyondTheVeil": "पर्दे के पार, सभी बिल एक हो जाते हैं...",
		"sequence": "1-2-3-4-5... पवित्र हॉप अनुक्रम पूरा हुआ!",
		"hyperElite": "हाइपर एलीट खरगोश स्थिति अनलॉक 🐇🐇🐇",
		"eventHorizon": "ब्रह्मांडीय खरगोश बिल के घटना क्षितिज से परे...",
		"matrixAwakens": "खरगोश बिल मैट्रिक्स में गड़बड़ी... आप वास्तविकता के पीछे गाजर देखते हैं",
		"luckyForever": "हर पंजा, हर छलांग, हर फड़कन... हमेशा के लिए आशीर्वादित",
		"twentyK": "बीस हज़ार। आप अब एक खरगोश नहीं हैं। आप वो खरगोश हैं।",
		"singularity": "खरगोश विलक्षणता। सभी खरगोश आप हैं। आप सभी खरगोश हैं।",
		"tripleAscension": "ब्रह्मांडीय खरगोश की तीन गुना उत्थान!",
		"ultimateAnswer": "42,000 - परम उत्तर शुरू से ही गाजर था",
		"eternity": "♾️ शाश्वत खरगोश बिल का कोई अंत नहीं है। आपका भी नहीं। ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} बोनस अंक!",
		"clickStreak": "🔥 {{count}} क्लिक स्ट्रीक!",
		"fire": "🔥 फायर पावर सक्रिय!"
	},
	"table": {
		"achievement": "उपलब्धि",
		"progress": "प्रगति"
	},
	"reset": {
		"confirm": "क्या आप वाकई सारी प्रगति रीसेट करना चाहते हैं? इसे वापस नहीं किया जा सकता।"
	}
}
